import api from "./api";

export async function login(credentials) {
  const response = await api.post("/auth/login", {
    username: credentials.username,
    password: credentials.password,
    device_name: "react_dashboard"
  });
  const { user, token } = response.data.data;
  localStorage.setItem("token", token);
  return user;
}

export async function logout() {
  await api.post("/auth/logout");
  localStorage.removeItem("token");
}
